export default function Error404() {
    return (
        <div style={{ minHeight: "60vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <h1>404 - Page Not Found</h1>
            <p>Oops! This page doesn't exist.</p>
        </div>
  );
}